<template>
  <div>
    <!-- modal -->
    <b-modal
      id="modal-edit-project"
      ref="edit-project-modal"
      title="Edition d'un projet"
      centered
      ok-title="Valider"
      cancel-title="Supprimer le projet"
      cancel-variant="outline-danger"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      @cancel="handleDelete"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          :state="nameState"
          label="Nom"
          label-for="name-input"
          invalid-feedback="Le nom est nécessaire"
        >
          <b-form-input
            id="name-input"
            v-model="updateProject.name"
            placeholder="Nom du projet"
            :state="nameState"
            required
          />
        </b-form-group>
        <b-form-group
          :state="descriptionState"
          label="Description"
          label-for="description-input"
          invalid-feedback="La description est nécessaire"
        >
          <b-form-textarea
            v-model="updateProject.description"
            placeholder="Description du projet"
            rows="3"
            :state="descriptionState && value.length <= maxChar"
            required
            class="char-textarea"
            :class="value.length >= maxChar ? 'text-danger' : ''"
          />
          <small
            class="textarea-counter-value float-right"
            :class="value.length >= maxChar ? 'bg-danger' : ''"
          >
            <span class="char-count">{{ value.length }}</span> / {{ maxChar }}
          </small>
        </b-form-group>
        <b-form-group label="Version" label-for="version-input">
          <b-form-input
            id="version-input"
            v-model="updateProject.version"
            placeholder="v1.0.0"
          />
        </b-form-group>
        <b-form-group label="URL" label-for="url-input">
          <b-form-input
            id="url-input"
            v-model="updateProject.URL"
            placeholder="https://www.project.com"
          />
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BModal,
  BFormTextarea,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import useProjects from "../useProjects";
import { ref } from "@vue/composition-api";

export default {
  components: {
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BModal,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      value: "",
      maxChar: 1024,
      nameState: null,
      descriptionState: null,
    };
  },
  watch: {
    "params.selectedProjectID"(val, oldVal) {
      if (val !== oldVal) {
        this.findProjectByID(val).then((project) => {
          this.updateProject = project;
        });
      }
    },
  },
  setup() {
    const { editProject, findProjectByID, deleteProjectByID } = useProjects();
    let updateProject = ref({});

    return {
      updateProject,
      editProject,
      findProjectByID,
      deleteProjectByID,
    };
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      this.descriptionState = valid;
      return valid;
    },
    resetModal() {
      this.nameState = null;
      this.descriptionState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleDelete() {
      this.deleteProjectByID(this.params.selectedProjectID).then(() => {
        this.$emit("update-project-list");
      });
      this.$refs["edit-project-modal"].toggle("#toggle-btn");
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }

      this.editProject(this.updateProject).then(() => {
        this.$emit("update-project-list");
        // Hide the modal manually
        this.$nextTick(() => {
          this.$refs["edit-project-modal"].toggle("#toggle-btn");
        });
      });
    },
  },
};
</script>
